export default (function (src) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$document = _ref.document,
    document = _ref$document === void 0 ? global.document : _ref$document,
    _ref$rejectOnError = _ref.rejectOnError,
    rejectOnError = _ref$rejectOnError === void 0 ? true : _ref$rejectOnError,
    _ref$attributes = _ref.attributes,
    attributes = _ref$attributes === void 0 ? {} : _ref$attributes;
  return new Promise(function (resolve, reject) {
    var script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.type = 'text/javascript';
    script.onerror = rejectOnError ? reject : resolve;
    script.onload = resolve;
    Object.keys(attributes).forEach(function (key) {
      script.setAttribute(key, attributes[key]);
    });
    document.body.appendChild(script);
  });
});